import { useCallback } from 'react'
import { useRouter } from '@tanstack/react-router'

export const useExtractRootSearchParams = () => {
    const router = useRouter()

    return useCallback(
        (searchParams: any) => {
            const validateSearch = router.routeTree.options.validateSearch
            if (validateSearch) {
                try {
                    if (typeof validateSearch === 'function') {
                        return validateSearch(searchParams)
                    }
                    if (typeof validateSearch === 'object' && validateSearch.parse) {
                        return validateSearch.parse(searchParams)
                    }
                } catch {
                    return {}
                }
            }

            return {}
        },
        [router]
    )
}
